import * as React from 'react';

import { DASHBOARD_SSO_WARNING } from 'src/ui/constants/testIds';
import { copy } from 'src/ui/templates/copy';
import { SSO_TOKEN_REQUIRED } from 'src/ui/utils/graphqlErrorCode';

interface SSOWarningProps {
  errorCode: string;
}

export const SSOWarning: React.VFC<SSOWarningProps> = ({ errorCode }) => {
  const message =
    errorCode === SSO_TOKEN_REQUIRED
      ? copy.errors.ssoTokenRequired
      : copy.errors.ssoTokenExchangeFailed;

  return (
    <div className="sd-warning" data-testid={DASHBOARD_SSO_WARNING}>
      {message}
    </div>
  );
};
